import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { generateArray, getAnimationDelay, getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function DotsLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  const dotsCount = 3;

  return (
    <div ref={ref} className={cn('wg-variant-loading__dots-container', getSizeClass(size), className)}>
      {generateArray(dotsCount).map(i => (
        <div
          key={i}
          className={cn('wg-variant-loading__dot', getSizeClass(size))}
          style={{ animationDelay: `${getAnimationDelay(i, 'dots')}ms` }}
        />
      ))}
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const DotsLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(DotsLoading);
DotsLoadingComponent.displayName = 'DotsLoading';

export default DotsLoadingComponent;
